import React, { useEffect, useState } from 'react';
import './MultipleStatistic.css';
import { alphabet } from '../../../static/utils';

const MultipleStatistic = ({ post, color }) => {
    const [reviewsCount, setReviewsCount] = useState([]);

    useEffect(() => {
        let arr = [];
        post.question.questions.forEach(elem => {
            arr.push(elem.reviews.length);
        });
        setReviewsCount(arr);
    }, []);

    const maxCount = Math.max(...reviewsCount);

    return (
        <div className="multiple-statistic">
            {reviewsCount &&
                reviewsCount.map((question, index) => (
                    <div key={alphabet[index]} className="multiple-statistic-item">
                        <div
                            style={{
                                backgroundColor: `${
                                    question === maxCount && question !== 0 && color
                                }`,
                                borderColor: `${question === maxCount && question !== 0 && color}`,
                                color: `${question === maxCount && question !== 0 && '#464A55'}`,
                            }}
                            className="multiple-statistic-circle"
                        >
                            {alphabet[index]}
                        </div>
                        <span
                            style={{ color: `${question === maxCount && question !== 0 && color}` }}
                        >
                            {question}
                        </span>
                    </div>
                ))}
        </div>
    );
};

export default MultipleStatistic;
